import { ReactLenis } from "@studio-freight/react-lenis"
import React from "react"

import Footer from "./footer"
import Header from "./header"

import "../scss/site.scss"

const SCROLL_OPTIONS = {
    duration: 1.2,
    orientation: "vertical",

    easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: true,
    wheelMultiplier: 1,
    smoothTouch: false,
}

export default function Layout({ children, privacy, bannerBorder, dark, brown, enquire, light, lightBorder, horizon, title, subtitle, hideBanner, homepage = false }) {
    return (
        <ReactLenis root options={SCROLL_OPTIONS}>
            <Header horizon={horizon} bannerBorder={bannerBorder} enquire={enquire} light={light} lightBorder={lightBorder} title={title} subtitle={subtitle} hideBanner={hideBanner} homepage={homepage} />
            <main>{children}</main>
            <Footer dark={dark} light={light} brown={brown} />
            {/* <EnquirePopup privacy={privacy} />
            <BrochurePopup privacy={privacy} /> */}
        </ReactLenis>
    )
}
